import styled, { css } from 'styled-components';

import { BaseStyle } from '@nhl/nhl-breakaway-ui';

import { CardItem } from '../../../../../../styles';
import { EventName } from '../../../../../specialEventMatchup/styles';

export const MobileDayContainer = styled.button`
    display: flex;
    flex-direction: column;
    width: 100%;
    height: 100%;
`;

export const MobileTopBar = styled.div`
    display: flex;
    width: 100%;
    justify-content: space-between;

    svg {
        width: 8px;
        height: 8px;
        margin-right: 3px;
        margin-top: 3px;
    }
`;

export const MobileDayOfMonth = styled.div`
    ${BaseStyle.Mixins.fontStyles.ui['10m']}
    height: 10px;
    margin-left: 4px;
    margin-top: 2px;
`;

export const MobileTeamDisplay = styled.div`
    ${BaseStyle.Mixins.fontStyles.ui['12b']}
    display: flex;
    width: 100%;
    height: 23px;
    align-items: center;
    text-align: center;
    && {
        justify-content: center;
        line-height: 20px;
    }
`;

export const MobileGameInfo = styled.div<{ $isLive: boolean; $isFrench: boolean }>`
    ${BaseStyle.Mixins.fontStyles.ui['10m']}
    width: 100%;
    height: 10px;
    justify-content: center;
    text-align: center;
    margin-bottom: 4px;
    text-transform: ${({ $isLive }) => ($isLive ? 'uppercase' : 'none')};

    ${BaseStyle.Mixins.screenSizes.small} {
        font-size: 7px;
    }

    ${({ $isLive, $isFrench }) =>
        $isLive &&
        ($isFrench
            ? css`
                  font-size: 8px;
                  font-weight: 700;
              `
            : css`
                  ${BaseStyle.Mixins.fontStyles.ui['10b']}
              `)}
`;

export const PopperContent = styled.div`
    padding: 1em;

    a {
        color: ${({ theme }) => theme.Text.primary};
    }

    ${CardItem}:last-child {
        border-bottom: initial;
    }
`;

export const AdditionalGamesContainer = styled.div`
    ${BaseStyle.Mixins.fontStyles.ui['10m']}
    margin-left: 1px;
`;

export const SpecialEventInformation = styled.div`
    ${BaseStyle.Mixins.fontStyles.ui['10m']}
    ${BaseStyle.Mixins.gaps.extraSmall}
    display: flex;
    flex-direction: column;
`;

export const EventCardItem = styled.button`
    align-items: center;
    border-bottom: 1px solid ${({ theme }) => theme.Surface.border};
    display: flex;
    width: 100%;
    justify-content: space-between;
    outline: none;
    padding: 10px 0 10px 10px;
    text-align: left;
`;

export const SpecialEventImage = styled.img`
    display: flex;
    width: 100%;
    max-height: 80px;
    justify-content: center;
    background-color: ${({ theme }) => theme.Surface.secondary};
    border-radius: 4px;
`;

export const MatchupInfoContainer = styled.div`
    display: flex;
    flex-direction: column;
    min-width: 100%;
    justify-content: center;
    align-items: center;
    background-color: ${({ theme }) => theme.Surface.secondary};
    border-radius: 4px;
    padding: 10px;

    ${EventName} {
        color: ${({ theme }) => theme.Text.primary};
    }
`;
